import { AbilityBuilder, Ability } from '@casl/ability';
import store from 'stores';

// configs
import { USER_ROLE, DRAWER_MENU_LABEL } from 'configs';

function defineAbilitiesFor(type: string) {
  const { can, cannot, build } = new AbilityBuilder(Ability);

  switch (type) {
    case USER_ROLE.ADMIN:
      can(['create', 'update', 'view', 'delete'], 'all');
      break;
    case USER_ROLE.CHIEF_COMMISSIONER:
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW);
      can(['view', 'create'], DRAWER_MENU_LABEL.USER_MASTER);
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW_EDIT);
      can(['view'], DRAWER_MENU_LABEL.DASHBOARD);
      break;
    case USER_ROLE.STATE_USER:
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW);
      can(['view'], DRAWER_MENU_LABEL.USER_STATE_PENDING);
      // can(['view', 'create'], DRAWER_MENU_LABEL.USER_MASTER);
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW_EDIT);
      can(['view'], DRAWER_MENU_LABEL.DASHBOARD);
      break;
    case USER_ROLE.STATE_COMMISSIONER:
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW);
      // can(['view', 'create'], DRAWER_MENU_LABEL.USER_MASTER);
      can(['view', 'create'], DRAWER_MENU_LABEL.USER_STATE_PENDING);
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW_EDIT);
      can(['view'], DRAWER_MENU_LABEL.DASHBOARD);
      break;
    case USER_ROLE.DISTRICT_USER:
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW);
      // can(['view', 'create'], DRAWER_MENU_LABEL.USER_MASTER);
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW_EDIT);
      can(['view'], DRAWER_MENU_LABEL.DASHBOARD);
      break;
    case USER_ROLE.DISTRICT_COLLECTOR:
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW);
      // can(['view', 'create'], DRAWER_MENU_LABEL.USER_MASTER);
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW_EDIT);
      can(['view'], DRAWER_MENU_LABEL.DASHBOARD);
      break;
    case USER_ROLE.NODAL_OFFICER:
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW);
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW_EDIT);
      can(['view'], DRAWER_MENU_LABEL.DASHBOARD);
      break;
    case USER_ROLE.AUTHORITY_USER:
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW);
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW_EDIT);
      can(['view'], DRAWER_MENU_LABEL.DASHBOARD);
      break;
    case USER_ROLE.LEAD:
      // menu
      can('view', DRAWER_MENU_LABEL.PLAY_BACKGROUND);
      can('view', DRAWER_MENU_LABEL.DASHBOARD);

      can('view', DRAWER_MENU_LABEL.PRODUCT);
      can('view', DRAWER_MENU_LABEL.PRODUCT_LIST);

      can('view', DRAWER_MENU_LABEL.KANBAN);
      can('view', DRAWER_MENU_LABEL.USERS);

      // action
      break;
    case USER_ROLE.GUEST:
      cannot(['create', 'update', 'view', 'delete'], 'all');
      break;
    case USER_ROLE.DePWD_USER:
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW);
      can(['view'], DRAWER_MENU_LABEL.COMPLAINT_VIEW_EDIT);
      can(['view'], DRAWER_MENU_LABEL.DASHBOARD);
      can(['view', 'create', 'update', 'delete'], DRAWER_MENU_LABEL.EVENT);
      can(['view', 'create', 'update', 'delete'], DRAWER_MENU_LABEL.INFORMATION);
      can(['view', 'create', 'update', 'delete'], DRAWER_MENU_LABEL.SCHEMES);
      can(['view', 'create', 'update', 'delete'], DRAWER_MENU_LABEL.OPPORTUNITY);
      can(['view', 'create', 'update', 'delete'], DRAWER_MENU_LABEL.RESOURCES);
      can(['view', 'create', 'update', 'delete'], DRAWER_MENU_LABEL.HELPLINES);
      can(['view', 'create', 'update', 'delete'], DRAWER_MENU_LABEL.NOTIFICATIONS);
      break;
  }
  return build();
}

const canAction = (action: string, resource: string) => {
  const role = store.getState().auth.role || '';
  if (!role) return false;

  const abilities = defineAbilitiesFor(role);
  return abilities.can(action, resource);
};

export default canAction;
